export const PRE_CONSTRUCTION = 'Pre-Construction'
export const CONSTRUCTION = 'Construction'
export const COMPLETE = 'Complete'

export default {
  PRE_CONSTRUCTION,
  CONSTRUCTION,
  COMPLETE,
}
